<header *ngIf="isOfferReadOnly" @headerReadonly (@headerReadonly.done)="carouselAnimation()" class="header-readonly">
  <span class="header-readonly-text">
    <span>{{ 'Page « {0} » is read-only.' | translate: { '0': (customerPage ? customerPage.title : '') } }}</span>
    <span>{{'No modifications are possible.' | translate}}</span>
  </span>
</header>

<mat-sidenav-container class="sidenav-container customer-container">
  <mat-sidenav *ngIf="isDesktop && !isEmbed" mode="side" opened class="sidenav">
    <app-pages-list style="height:calc(100% - 120px);display:flex;overflow-y: auto;"
                    #pagesList
                    [pageKeys]="pageKeys"
                    [customer]="customer"
                    [userRole]="userRole"
                    [sso]="sso"
                    [pageId]="pageId"
                    [pagesMap]="pagesMap"
                    (emitGoToBlock)="goToStep($event)"></app-pages-list>
    <div class="page-footer">
      <p class="copyright">© {{currentYear}} <a href="https://www.solocal.com/" target="_blank" rel="noopener">solocal.com</a></p>
      <p class="legal-links">
        <a href="https://www.solocal.com/mentions-legales" target="_blank" rel="noopener">{{ 'Legal notices' | translate }}</a>
        <a href="https://www.solocal.com/protection-de-la-vie-privee" target="_blank" rel="noopener">{{ 'Privacy' | translate }}</a>
        <a href="https://www.solocal.com/cookies" target="_blank" rel="noopener">{{ 'Cookie information' | translate }}</a>
      </p>
    </div>
  </mat-sidenav>
  <mat-sidenav #pagesMobileMenu *ngIf="!isDesktop && !isEmbed" mode="side" position="end" opened class="sidenav">
    <app-pages-list #pagesList
                    [pageKeys]="pageKeys"
                    [customer]="customer"
                    [userRole]="userRole"
                    [sso]="sso"
                    [pageId]="pageId"
                    [pagesMap]="pagesMap"
                    (emitCloseMenu)="closeMenu()"
                    (emitGoToBlock)="goToStep($event)">
    </app-pages-list>
  </mat-sidenav>
  <mat-sidenav-content #mainContent class="mainContent" *ngIf="customerPage" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)" (scroll)="onScroll()">
    <div #headerCarousel class="headTop" *ngIf="!isEmbed">
      <div class="headTop-section-1" [ngClass]="{'desktop': isDesktop}">
        <div class="column-1-1">
          {{ 'Welcome' | translate }}
          <span *ngIf="userRole == RoleType.ADMIN && isDesktop"
                class="page-version">
            {{customerPage.version}}
          </span>
        </div>
        <div #offerTitle class="column-1-2 nomOffre" tooltipTruncate [matTooltip]="customerPage.title!"> <span *ngIf="customerPage.type == 0">{{ 'My offer' | translate }}</span> {{customerPage.title}}</div>
      </div>
      <div class="headTop-section-2" *ngIf="!isDesktop">
        <div class="percentage-container" [ngClass]="{
             'spinner-success' : fetchPageStats(customerPage.id!) === 100,
             'spinner-processing' : fetchPageStats(customerPage.id!) === undefined || fetchPageStats(customerPage.id!)! < 100
        }">
          <mat-progress-spinner
            class="title-spinner"
            [value]="fetchPageStats(customerPage.id!)"
            mode="determinate"
            strokeWidth="6"
            diameter="55"
            [color]="fetchPageStats(customerPage.id!)! < 100 ? 'accent' : 'primary'">
          </mat-progress-spinner>

          <div class="percentage-text circle" [ngClass]="{ 'percentage-text-spacing': fetchPageStats(customerPage.id!) === 100 }">
            <ng-container *ngIf="fetchPageStats(customerPage.id!) === 100 && customerPage.completionStatus == CompletionStatus.COMPLETED; else showPercentage">
              <mat-icon>check</mat-icon>
            </ng-container>
            <ng-template #showPercentage>
              {{ fetchPageStats(customerPage.id!) }}%
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div #progressBar *ngIf="!isEmbed" class="progress-bar progress-bar-mobile">
        <div class="step"
             *ngFor="let block of customerPage.blocks; let i = index"
             [class.check]="i <= currentStep">
        </div>
      </div>
    </div>

    <div #carousel class="cdc-carousel">
      <ng-container class="cdc-carousel-block"
                    *ngFor="let block of customerPage.blocks; let i = index">
        <div class="cdc-carousel-block"
             *ngIf="i < (currentStep + 1) || (i >= (currentStep + 1) && !isEmbed)"
             [ngClass]="{'previousItem': i < currentStep, 'activeItem': i === currentStep,'nextItem': i >= (currentStep + 1)}"
             [attr.data-blockid]="block.id" [attr.data-blockiteration]="block.iteration" #carouselBlock>
          <!--hide only previous blocks, because of later error tooltips-->
          <div class="cdc-block" [ngStyle]="{ display: i < currentStep ? 'none' : 'block' }">
            <app-block-form *ngIf="currentStep < customerPage.blocks!.length"
                            [customer]="customer"
                            [customerPage]="customerPage"
                            [userRole]="userRole"
                            [block]="block"
                            [customersData]="customerPageDatas"
                            (customersDataChange)="handleCustomerPageDatasChange($event)"
                            (openHelpDialog)="onOpenHelpDialog()"
                            [currentBlockId]="currentBlockId"
                            [currentBlockIteration]="currentBlockIteration"
                            [isSummary]="false"
                            [offerStatus]="offerStatus"
                            [refBusinessLists]="refBusinessLists"
                            [fullConnectionsDefinitions]="fullConnectionsDefinitions"
                            [isCurrentBlock]="i == currentStep"
                            (checkErrors)="checkErrorsOnCurrentBlock()">
            </app-block-form>
          </div>

        </div>
      </ng-container>

      <div class="cdc-carousel-block doneItem "
           [ngClass]="{'previousItem': (customerPage.blocks!.length + 1) < currentStep, 'activeItem': (customerPage.blocks!.length + 1) === currentStep,'nextItem': (customerPage.blocks!.length + 1) >= (currentStep + 1)}" #carouselBlock>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <ng-container *ngIf="incompletePages.length > 0 && !isEmbed; else noIncomplete">
            <div class="slideTitle">

            </div>
            <div class="slideContent">

              <div class="incompletePages">
                <div class="doneItem-title">{{ ("We still need you !" | translate) }}</div>
                <p class="doneItem-sub-title">
                  {{ "The following form(s) are not 100% complete:" | translate }}
                </p>
                <div class="incomplete-page" *ngFor="let incPage of incompletePages">
                  <mat-icon>notifications</mat-icon>
                  <button matButton class="cdc-button" [routerLink]="['/customer/'+ customer.id + '/page/' + incPage.id]">
                    <div class="percentage-container"
                         [ngClass]="{'spinner-success' : incPage.completionPercent === 100, 'spinner-processing' : incPage.completionPercent! < 100}">
                      <mat-progress-spinner class="title-spinner"
                                            [value]="incPage.completionPercent"
                                            mode="determinate"
                                            strokeWidth="3"
                                            diameter="37">
                      </mat-progress-spinner>

                      <div class="percentage-text" [ngClass]="{ 'percentage-text-spacing': incPage.completionPercent === 100 }">
                        {{ incPage.completionPercent }}%
                      </div>
                    </div>
                    <span class="incomplete-page-title">
                      {{ incPage.title }}
                    </span>
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noIncomplete>
            <div class="slideTitle">
              <ng-container *ngIf="(stripHtml(customerPage.blockDone!.title)).length > 0; else defaultMessage">
                <div class="component-html-wrapper" #htmlWrapper [innerHtml]="sanitizeHtml(customerPage.blockDone!.title)">
                </div>
              </ng-container>

              <ng-template #defaultMessage>
                {{ "You are finished." | translate }}
                <p>{{ "Thank you for your participation !" | translate }}</p>
              </ng-template>
              <div class="navigation" style="margin: 25px;">
                <button class="cdc-button cdc-button-next summary" *ngIf="isEmbed" (click)="CloseButtonEmbed()" mat-flat-button>
                  {{ (customerPage.blockDone?.buttonText?.trim()?.length ?? 0) > 0 ? customerPage.blockDone?.buttonText : ("Close window" | translate)}}
                </button>
              </div>
            </div>
            <div class="slideContent completed">
              <img src="../../../../assets/images/done_2.jpg" alt="" class="block-done-img">
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="cdc-carousel-bottom-parent" #footerCarouselParent>
      <div class="cdc-carousel-bottom" #footerCarousel>

        <div #progressBar *ngIf="!isEmbed" class="progress-bar progress-bar-desktop">
          <div class="step"
               *ngFor="let block of customerPage.blocks; let i = index"
               [class.check]="i <= currentStep">
          </div>
        </div>
        <div #navigation class="navigation" [class.invisible]="activeDone">
          <div class="button-wrapper-left">
            <button class="cdc-button cdc-button-previous previous" mat-flat-button (click)="previousStep()" [disabled]="currentStep === 0" [ngClass]="{ 'deactivated': currentStep === 0 }">
              <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
                <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
                <defs>
                  <style>
                    .st0 {
                      fill: #fff;
                    }
                  </style>
                </defs>
                <polygon class="st0" points="8.9 16.3 3 9.6 8.9 2.9 10.4 4.3 5.7 9.6 10.4 15 8.9 16.3" />
              </svg>
              {{isDesktop || isEmbed ? ('Previous' | translate) : ''}}
            </button>
          </div>
          <div class="button-wrapper-right">
            <ng-container *ngIf="currentStep < customerPage.blocks!.length - 1">
              <button class="cdc-button cdc-button-next next" mat-flat-button (click)="nextStep()">
                {{isDesktop || isEmbed ? ('Next' | translate) : ''}}
                <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
                  <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
                  <defs>
                    <style>
                      .st0 {
                        fill: #fff;
                      }
                    </style>
                  </defs>
                  <polygon class="st0" points="5.1 16.3 3.6 15 8.3 9.6 3.6 4.3 5.1 2.9 10.9 9.6 5.1 16.3" />
                </svg>
              </button>
            </ng-container>
            <ng-container *ngIf="currentStep == customerPage.blocks!.length - 1 && !isOfferReadOnly && isSubmittable && userRole != RoleType.INTERN">
              <button class="cdc-button cdc-button-next summary" mat-flat-button (click)="nextStep()">
                {{isDesktop || isEmbed ? ('Summary' | translate) : ''}}
                <mat-icon>remove_red_eye</mat-icon>
              </button>
            </ng-container>
            <div class="custom-tooltip cdc-block-error" [class.invisible]="!blockHasErrors">{{ 'Please check the error fields' | translate }}</div>
          </div>
        </div>
        </div>
    </div>

    <div *ngIf="isDesktop && ((pageGuide != undefined && pageGuide.length > 0) || (blockGuide != undefined && blockGuide.length > 0))" class="sidenav-btn">
      <button (click)="sidenavToggle()" matTooltip="{{ 'Guide' | translate }}"
              class="expand-button-left">
        <mat-icon class="side-bar-icon">info_outline</mat-icon>
      </button>
    </div>

  </mat-sidenav-content>

  <mat-sidenav #sidenav *ngIf="isDesktop && ((pageGuide != undefined && pageGuide.length > 0) || (blockGuide != undefined && blockGuide.length > 0))"
               position="end"
               mode="side"
               class="main-content sidenav-right">
    <div class="page-guide">
      <span mat-button class="guide-title">
        <span class="guide-title-text mx-auto">{{ "Guide" | translate }}</span>
      </span>

      <div class="page-guide-content scroll-left">
        <div class="component-html-wrapper" #htmlWrapper  [innerHtml]="sanitizeHtml(pageGuide)"></div>
        <hr *ngIf="(pageGuide != undefined && pageGuide.length > 0) && (blockGuide != undefined && blockGuide.length > 0)">
        <div class="component-html-wrapper" #htmlWrapper [innerHtml]="sanitizeHtml(blockGuide)"></div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>

